<template>
  <div>
    <div class="top">
      <div class="top1">
        <span>{{ $t('newRegister.step1') }}</span>
      </div>
      <img :src="require('@/assets/img/progress-icon.png')" alt="" style="width: 9px; height: 9px">
      <img :src="require('@/assets/img/progress-icon.png')" alt="" style="width: 9px; height: 9px">
      <img :src="require('@/assets/img/progress-icon.png')" alt="" style="width: 9px; height: 9px">
      <img :src="require('@/assets/img/progress-icon.png')" alt="" style="width: 9px; height: 9px">
      <div class="top1 top2">
        <span>{{ $t('newRegister.step2') }}</span>
      </div>
    </div>
    <div class="select-community" v-if="type!='zuke'&&depth != 5 && !hasOrgId && !depth || depth == 4">
      <div class="select" @click="communityShow = true">
        <span>选择社区</span>
        <van-icon name="arrow" size="18" color="rgba(102, 102, 102, 0.66)" />
      </div>
      <div class="community">
        {{communityName}}
      </div>
    </div>
    <van-popup v-model="communityShow" position="bottom">
      <van-picker show-toolbar value-key="name" :columns="communityList" @confirm="communityConfirm"
                  @cancel="communityShow = false" />
    </van-popup>
    <div class="select-registryType">
      <div class="title">
        <span>{{ $t('newRegister.householdType') }}<span class="title-sub">{{ $t('newRegister.multiSelect') }}</span></span>
      </div>
      <van-checkbox-group v-model="registryType">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in registryTypeList"
            v-show="item.state"
            clickable
            :key="item.value"
            :title="item.labelKey ? $t(item.labelKey) : item.label"
            @click="toggle(index,item)"
          >
            <template #right-icon>
              <van-checkbox :name="item.value" ref="checkboxes" >
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-checkbox>
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>

    <!-- zuke 入口：底部固定栏 + 入住须知 -->
    <template v-if="type=='zuke'">
      <div class="bottom-bar">
        <label class="agree-row">
          <van-checkbox v-model="agreeChecked" :disabled="!termsConfirmed" class="agree-check">
            <span>{{ $t('newRegister.iHaveReadAndAgree') }}</span>
          </van-checkbox>
          <span class="terms-link" @click="openTerms">{{ $t('newRegister.checkInNotice') }}</span>
        </label>
        <p class="countdown-text" v-if="!termsConfirmed && showCountdown">
          <span>{{ $t('newRegister.pleaseRead', { n: countdown }) }}</span>
        </p>
        <button class="next-btn" @click="toRegister">
          <span>{{ $t('newRegister.next') }}</span>
        </button>
      </div>
    </template>

    <!-- 非 zuke 入口：保持原简单按钮 -->
    <div class="btn" v-else @click="toRegister">
      <span>下一步</span>
    </div>

    <!-- 入住须知弹窗 -->
    <van-popup v-model="showTerms" position="bottom" round :close-on-click-overlay="false" class="terms-popup">
      <div class="terms-hd">
        <h2>{{ $t('newRegister.checkInNoticeTitle') }}</h2>
      </div>
      <div class="terms-bd">
        <template v-if="$lang === 'zh-CN'">
          <div class="terms-sec"><h4>一、居住</h4><h5>1、租房</h5>
            <p><strong>1.1 在哪儿租房？</strong></p><p>您可以选择正规的租房中介公司帮您寻找合适的房源。在中国，不少租房中介公司都有自己的线上平台，您可以提前在网站上，根据租金、地段、房屋状况等条件搜索房源。当然，您也可以直接去租房中介公司的门店，找租房经纪人当面详谈。通常，租房中介会陪您一同上门考察房源。</p>
            <p><strong>1.2 如何签订租房合同？</strong></p><p>若您对所看的房屋感到满意并确定了租赁意向，您需要同房东签订租房合同，约定租赁期限、租赁用途、租赁价格、修缮责任等条款，以及双方的其他权利和义务，并交付相关费用，包括押金和租金，再向房产管理部门登记备案。为了尽可能避免租房中的纠纷，一般会签订双语租房合同，但应尽量以其中一种语言为准，以免产生歧义。</p>
            <p><strong>1.3 如何办理住宿登记？</strong></p><p>根据规定，您需要在入住的24小时之内，由本人或者房东，前往当地公安机关办理住宿登记，否则将会被处罚。入住房屋后，您必须遵守合同规定，保持房屋的安全和清洁。请注意居住时保持安静，不要大声喧哗，否则很可能遭到邻居的投诉。</p>
          </div>
          <div class="terms-sec"><h5>2、购房</h5>
            <p><strong>2.1 是否有购房资格？购房数量是否有限制？</strong></p><p>在购房前，您需要确定自己是否具有购房资格。关于外国人在中国购买商品房的政策，各地有所不同，但总体上，在境内设立分支、代表机构的境外机构和在境内工作、学习的境外个人，可以购买符合实际需要的自用、自住商品房。另外，对于实施住房限购政策的城市，应当符合当地政策规定。</p>
            <p><strong>2.2 产权登记须提供哪些材料？</strong></p><p>在办理商品房预售合同备案和房屋产权登记时，您应当提供：1. 有关部门出具的境外个人（不含港澳台居民和华侨）在境内工作超过一年的证明；港澳台居民和华侨在境内工作、学习和居留的证明。2. 境外个人名下在境内无其他住房的书面承诺。</p>
            <p><strong>2.3 如何申请购房结汇？</strong></p><p>境外机构和个人申请购房结汇，应当严格按照《关于规范房地产市场外汇管理有关问题的通知》办理。</p>
            <p><strong>2.4 土地使用年限是多长？</strong></p><p>在中国，土地使用权都有一定的年限，从40年到70年不等，其中商业、旅游、娱乐用地为40年，住宅用地为70年。2020年1月1日起施行的《中华人民共和国民法典》第359条明确规定"住宅建设用地使用权期限届满的，自动续期"。您可以委托当地的房地产中介，协助您办理寻找房源、价格谈判、签订合同、交易过户等手续。</p>
            <p><strong>2.5 境外机构能买房吗？</strong></p><p>在境内设立分支、代表机构的境外机构只能在注册城市购买办公所需的非住宅房屋。法律法规另有规定的除外。</p>
            <p class="terms-tip">小贴士 | 住房和城乡建设部 www.mohurd.gov.cn</p>
          </div>
          <div class="terms-sec"><h4>二、交通</h4>
            <p><strong>2.1 去哪里办公交卡？</strong></p><p>可以在地铁站、公交站或者手机公交App上办理。</p>
            <p><strong>2.2 怎么办公交卡？</strong></p><p>公交卡可直接购买，不需要身份证明文件。</p>
            <p><strong>2.3 怎么给公交卡充值？</strong></p><p>在任一地铁站可以充值，也可以在手机公交App上充值。可使用现金、微信、支付宝以及手机公交App上支持的支付方式等。</p>
            <p><strong>2.4 外国人可以骑共享单车吗？</strong></p><p>可以。使用微信、支付宝或者下载共享单车要求的手机App扫码后使用。</p>
            <p><strong>2.5 在中国怎么坐出租汽车？</strong></p><p>您可以在路边停车处招手示意，也可以通过打车App或微信、支付宝、地图软件的打车接口进行网络叫车服务，还可以拨打出租汽车公司的叫车服务电话叫车。</p>
            <p><strong>2.6 如何申请中国临时驾驶许可？</strong></p><p>持护照和有效签证等身份证件、境外机动车驾驶证到入境地或居住地公安机关交通管理部门车辆管理所申请小型汽车或摩托车临时驾驶许可。临时驾驶许可有效期内可多次入境使用，无须重新申请。持临时驾驶许可的，可以驾驶自带的临时入境机动车或租赁的中国机动车。驾驶自带临时入境机动车的，临时驾驶许可准驾车型应当与自带机动车的车型一致。驾驶租赁中国机动车的，临时驾驶许可的准驾车型为小型汽车和小型自动挡汽车。</p>
            <p><strong>2.7 如何申请换领中国正式驾驶证？</strong></p><p>持护照、入境居（停）留期为3个月以上的有效签证或者停留、居留证件等有效身份证件，境外机动车驾驶证，以及公安机关核发的住宿登记证明和县级以上医疗机构出具的有关身体条件证明到居住地公安机关交通管理部门车辆管理所申请换领驾驶证。申请中国临时驾驶许可或正式驾驶证的外国人，所持境外机动车驾驶证属于非中文表述的，还应当出具中文翻译文本。</p>
            <p><strong>2.8 如何在中国考领机动车驾驶证？</strong></p><p>年满18岁，持护照、入境居（停）留期为3个月以上的有效签证或者停留、居留证件等有效身份证件，以及公安机关核发的住宿登记证明和县级以上医疗机构出具的有关身体条件证明到居留地或居住地公安机关交通管理部门车辆管理所申请考领驾驶证，考试合格后，即可获得中国正式机动车驾驶证。</p>
            <p><strong>2.9 怎样在中国买到一张火车票？</strong></p><p>持本人有效身份证件（护照或外国人永久居留身份证）到火车站或代售点购买。也可以登录12306网站（www.12306.cn）凭借有效护照编号购票，届时再去车站或代售点取票。</p>
          </div>
          <div class="terms-sec"><h4>三、通信</h4>
            <p><strong>3.1 从国外怎么给中国北京的座机打电话？</strong></p><p>86-10（北京区号）-XXXXXXXX</p>
            <p><strong>3.2 在中国怎么给中国北京的座机打电话？</strong></p><p>010（北京区号）-XXXXXXXX</p>
            <p><strong>3.3 去哪里办电话、手机、宽带，要带什么？</strong></p>
            <p>您可以登录中国的电信运营商官方网站或者持本人有效护照前往营业厅。例如：</p>
            <p>中国移动通信 CHINA MOBILE | www.10086.cn</p>
            <p>中国联通 China unicom | www.10010.com</p>
            <p>中国电信 CHINA TELECOM | www.chinatelecom.com.cn</p>
            <p>⚠️ 在中国境内办理电话卡需进行实名认证，如不再使用，需前往营业厅办理销户手续。</p>
          </div>
        </template>
        <template v-else>
          <div class="terms-sec"><h4>I. Accommodation</h4><h5>1. Renting Accommodation</h5>
            <p><strong>1.1 Where to rent accommodation?</strong></p><p>You can use a formal real estate agency to look for housing. In China, many real estate agencies have their own online platforms. You can search for apartments in advance on the website according to the price, location, apartment type, and other conditions. Of course, you can also go directly to the real estate agencies and talk to the agents in person. Usually, an agent will accompany you to visit the apartments.</p>
            <p><strong>1.2 How to sign a rental contract?</strong></p><p>If you are satisfied with the apartment you have seen and decide to rent it, you need to sign a rental contract with the landlord, agreeing on the terms of the duration, purpose, price, maintenance responsibilities, and other rights and obligations of both parties, and pay related expenses, including deposit and rent, and then register with the real estate administration department. In order to avoid disputes in renting, bilingual rental contracts are generally signed, but one language should prevail as far as possible to avoid ambiguity.</p>
            <p><strong>1.3 How to complete residence registration?</strong></p><p>You or the host shall go to the local police station for residence registration within 24 hours after you move in, otherwise you will face punishment. After moving into the apartment, you must abide by the contract and keep the house safe and clean. Please keep noise to a minimum in the apartment, or you may get complaints from neighbors.</p>
          </div>
          <div class="terms-sec"><h5>2. Purchasing Real Estate Property</h5>
            <p><strong>2.1 Am I eligible to purchase real estate property? Is there a limit on the number of real estate properties to purchase?</strong></p><p>Before purchasing a real estate property, you need to check whether you are eligible to do so. Policies regarding foreigners' purchase of commercial real estate property in China vary from place to place, but in general, overseas organizations that have branches and representative offices in China, and overseas individuals working and studying in China can purchase self-use and self-occupied commercial properties that meet their actual needs. In addition, for cities that implement housing purchase restrictions, you should comply with local policies and regulations.</p>
            <p><strong>2.2 What materials are needed for property registration?</strong></p><p>When filing the pre-sale contract of commercial housing and the housing property registration, you should provide: 1. A certificate issued by relevant departments that the foreign individual (excluding residents of Hong Kong, Macao, Taiwan regions of China and overseas Chinese) has worked in China for more than one year, or that residents of Hong Kong, Macao, Taiwan regions of China and overseas Chinese work, study, and reside in China. 2. A written commitment that there is no other housing in the country under the same name.</p>
            <p><strong>2.3 How to apply for foreign exchange settlement for real estate purchase?</strong></p><p>Overseas organizations and individuals applying for the settlement of foreign exchange for real estate purchase shall strictly follow the Notice on Regulating the Administration of Foreign Exchange in the Real Estate Market.</p>
            <p><strong>2.4 What is the duration of land-use rights?</strong></p><p>In China, there is a limit on duration for land-use rights ranging from 40 to 70 years: a maximum of 40 years for the use of commerce, tourism, and entertainment, and 70 years for residential use. The Civil Code of the People's Republic of China that came into effect on January 1, 2020 clearly stipulates in Article 359 that "when the land-use rights for residential use expire, they will be automatically renewed." You can entrust a local real estate agency to assist you in house hunting, price negotiation, contract signing, transaction transfers, and other procedures.</p>
            <p><strong>2.5 Can overseas organizations purchase a real estate property?</strong></p><p>Overseas organizations that set up branches and representative offices in China can only purchase non-residential properties needed for office work in their registered cities, unless laws and regulations state otherwise.</p>
            <p class="terms-tip">TIPS | Ministry of Housing and Urban-Rural Development (MOHURD) www.mohurd.gov.cn</p>
          </div>
          <div class="terms-sec"><h4>II. Transportation</h4>
            <p><strong>2.1 Where to get a public transportation card?</strong></p><p>You can get one at metro stations, bus stations, or via related mobile apps.</p>
            <p><strong>2.2 How to get a public transportation card?</strong></p><p>You can buy one directly without identification documents.</p>
            <p><strong>2.3 How to recharge a public transportation card?</strong></p><p>You can recharge the card at any metro station or on the related mobile apps. You can use cash, WeChat, Alipay, or other payment methods supported on the mobile apps.</p>
            <p><strong>2.4 Can foreigners use shared bikes?</strong></p><p>Yes. You can use them by scanning the QR code on the shared bikes through WeChat, Alipay, or other relevant mobile apps.</p>
            <p><strong>2.5 How to take a taxi in China?</strong></p><p>You can get a taxi by simply flagging one down at a taxi standing zone on the street. You can also use taxi apps, or ride hailing services via WeChat, Alipay, or various map apps, or make a reservation phone call to a taxi company.</p>
            <p><strong>2.6 How to apply for a temporary driving license?</strong></p><p>You can apply for a temporary driving license at the local vehicle administration office of the traffic administration department of the public security bureau where you enter China or reside, by providing your ID documents, such as a passport and valid visa, and overseas driving license. A temporary driving license can be used for multiple entries to China before the expiry date without reapplication. You can drive your own motor vehicle brought to China or a rented one in China with a temporary driving license. For those who bring their own motor vehicles to China, the type of vehicle should be the same as the one permitted on the temporary driving license. For those who rent motor vehicles in China, small cars and small automatic vehicles are permitted with a temporary driving license.</p>
            <p><strong>2.7 How to convert your driving license in China?</strong></p><p>You can apply to convert your temporary driving license to a formal Chinese one at the local vehicle administration office of the traffic administration department of the public security bureau where you reside, with the following documents: valid ID documents such as passport, valid visa for stay/residence of more than 3 months, your overseas driving license, the residence registration certificate issued by the local police station, and the physical health condition certificate issued by medical organizations at or above the county level. Foreigners who apply for a temporary driving license or a formal driving license in China shall also have their overseas driving license translated into Chinese.</p>
            <p><strong>2.8 How to take a driving test in China?</strong></p><p>You can apply for the test of a formal driving license at the local vehicle administration office of the traffic administration department of the public security bureau where you reside if you are above 18 years old, with the following documents: valid ID documents such as passport, valid visa for stay/residence of more than 3 months, the residence registration certificate issued by the local police station, and the physical health condition certificate issued by medical organizations at or above the county level. If you pass the test, you can get a formal motor vehicle driving license in China.</p>
            <p><strong>2.9 How to buy a train ticket in China?</strong></p><p>You can buy a train ticket at a railway station or a ticket agency with a valid ID (passport or Foreign Permanent Residence ID Card). You may also log on to the China Railway's website (www.12306.cn) to buy a ticket with a valid passport number, and then go to a railway station or a ticket agency to collect the ticket.</p>
          </div>
          <div class="terms-sec"><h4>III. Telecommunications</h4>
            <p><strong>3.1 How to make an international landline call to Beijing from abroad?</strong></p><p>86-10 (Beijing Area/Telephone Code) - XXXXXXXX</p>
            <p><strong>3.2 How to make a landline call to Beijing from within China?</strong></p><p>010 (Beijing Area/Telephone Code) - XXXXXXXX</p>
            <p><strong>3.3 How to get a number for a landline, a mobile phone, or set up internet?</strong></p>
            <p>You can log on to the official website of a Chinese telecom operator or visit their branches with your valid passport.</p>
            <p>CHINA MOBILE | www.10086.cn</p>
            <p>China unicom | www.10010.com</p>
            <p>CHINA TELECOM | www.chinatelecom.com.cn</p>
            <p>⚠️ Real-name authentication is required to apply for a SIM card in China. If you no longer use a number, you must cancel the account in branch.</p>
          </div>
        </template>
      </div>
      <div class="terms-ft">
        <button :disabled="countdown > 0" @click="confirmTerms" class="terms-btn">
          <span>{{ $t('newRegister.iHaveReadAndAgree') }}</span>
          <span v-if="countdown > 0">（{{ countdown }}s）</span>
        </button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: "newRegister",
  data () {
    return {
      type:sessionStorage.getItem('typeAdd'),
      title: '',
      depth: this.$qrcodeDepth || this.$depth,
      hasOrgId: false,
      communityShow: false,
      communityName: '',
      communityList: [],
      showTerms: false,
      agreeChecked: false,
      termsConfirmed: false,
      countdown: 10,
      countdownTimer: null,
      showCountdown: false,
      activeIcon: require('@/assets/img/selected.png'),
      inactiveIcon: require('@/assets/img/select.png'),
      registryType: [],
      registryTypeList: [{
        label: '我的户口在本社区',
        value: 1,
        state:true,
        trueState:true,
      }, {
        label: '我居住在本社区',
        value: 2,
        state:true,
        trueState:true,
      }, {
        label: '我是本社区集体户',
        value: 3,
        state:true,
        trueState:true,
      }, {
        label: '我有房在本社区',
        value: 4,
        state:true,
        trueState:true,
      }, {
        label: '我是本市户口租客',
        labelKey: 'newRegister.localTenant',
        value: 5,
        state:true,
        trueState:true,
      }, {
        label: '我是非本市户口租客',
        labelKey: 'newRegister.nonLocalTenant',
        value: 6,
        state:true,
        trueState:true,
      }, {
        label: '我是其他人员',
        value: 7,
        state:true,
        trueState:true,
      }, {
        label: '我是境外人员',
        labelKey: 'newRegister.foreignNational',
        value: 8,
        state:true,
        trueState:true,
      }]
    }
  },
  destroyed() {
    clearInterval(this.countdownTimer)
  },
  created() {
    this.type=this.$route.query.type||''
    this.registryType = []
    if (!this.depth || this.depth == 4) {
      this.$http({
        url: this.$http.adornUrl(`/wxapp/sys/org/communityList`),
        method: 'get',
        params: this.$http.adornParams({
          street: this.$globalData.userInfo.street || this.$orgId
        })
      }).then(({ data }) => {
        if (data.code == 0) {
          this.communityList = data.communityList
        }
      })
    }

    if(this.type=='zuke'){
      this.registryTypeList=this.registryTypeList.filter((item=>item.value==5||item.value==6||item.value==8))
    }

    if(this.$route.query.isSelf == 1) {
      this.title = this.$route.query.title
      this.hasOrgId = true
      this.registryTypeList = this.registryTypeList.map(item => {
        return {
          ...item,
          label: item.label.replace('我','他/她')
        }
     })
    }
    if(this.$houseId) {
      this.hasOrgId = true
    }
    if((this.$isTenant == 1 || this.$isTenant == 0) && (this.$houseId || this.$buildingId)) {
      // 房屋扫码进入不显示 居住在本社区 我是其他人员
      this.registryTypeList = this.registryTypeList.filter(item => {
        return item.value != 2 && item.value != 7
      })

      // 默认选中 居住在本社区
      this.registryType.push(2)
    }
  },
  methods: {
    communityConfirm (e) {
      Vue.prototype.$orgId = parseInt(e.id)
      this.communityName = e.name
      this.communityShow = false
    },
    openTerms() {
      this.showTerms = true
      this.countdown = 10
      clearInterval(this.countdownTimer)
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
        }
      }, 1000)
    },
    confirmTerms() {
      if (this.countdown > 0) return
      this.showTerms = false
      clearInterval(this.countdownTimer)
      this.termsConfirmed = true
      this.showCountdown = true
      this.countdown = 10
      this.countdownTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer)
          this.showCountdown = false
        }
      }, 1000)
    },
    toggle(index,item) {
      // 先 toggle 互斥项的 trueState，再 forEach 同步 state
      if(item.value==5){
        if(this.type=='zuke'){
          this.registryTypeList[index+1].trueState = !this.registryTypeList[index+1].trueState
          if(this.registryTypeList[index+2] && this.registryTypeList[index+2].value==8){
            this.registryTypeList[index+2].trueState = !this.registryTypeList[index+2].trueState
          }
        } else {
          this.registryTypeList[index+1].trueState = !this.registryTypeList[index+1].trueState
        }
        this.registryTypeList.forEach(item => {
          if (item.value === 6&&item.trueState===false) { item.state = false; }
          if (item.value === 6&&item.trueState===true) { item.state = true; }
          if (item.value === 8&&item.trueState===false) { item.state = false; }
          if (item.value === 8&&item.trueState===true) { item.state = true; }
          if (item.value === 5) { item.state = true; }
        });
      }

      if(item.value==6){
        if(this.type=='zuke'){
          this.registryTypeList[index-1].trueState = !this.registryTypeList[index-1].trueState
          if(this.registryTypeList[index+1] && this.registryTypeList[index+1].value==8){
            this.registryTypeList[index+1].trueState = !this.registryTypeList[index+1].trueState
          }
        } else {
          this.registryTypeList[index-1].trueState = !this.registryTypeList[index-1].trueState
        }
        this.registryTypeList.forEach(item => {
          if (item.value === 5&&item.trueState===false) { item.state = false; }
          if (item.value === 5&&item.trueState===true) { item.state = true; }
          if (item.value === 8&&item.trueState===false) { item.state = false; }
          if (item.value === 8&&item.trueState===true) { item.state = true; }
          if (item.value === 6) { item.state = true; }
        });
      }

      if(item.value==8){
        this.registryTypeList[index-2].trueState = !this.registryTypeList[index-2].trueState
        this.registryTypeList[index-1].trueState = !this.registryTypeList[index-1].trueState
        this.registryTypeList.forEach(item => {
          if (item.value === 5&&item.trueState===false) { item.state = false; }
          if (item.value === 5&&item.trueState===true) { item.state = true; }
          if (item.value === 6&&item.trueState===false) { item.state = false; }
          if (item.value === 6&&item.trueState===true) { item.state = true; }
          if (item.value === 8) { item.state = true; }
        });
      }

      this.$refs.checkboxes[index].toggle();
    },
    toRegister() {
      if ((!this.hasOrgId && !this.depth || this.depth == 4) && (!this.$orgId || this.$orgId == 'undefined')) {
        return this.$toast.fail('请选择社区')
      } else if (!this.registryType.some(v => this.registryTypeList.some(item => item.value === v))) {
        return this.$toast.fail(this.$t('newRegister.pleaseSelectHouseholdType'))
      } else if (this.type == 'zuke' && !this.agreeChecked) {
        return this.$toast.fail(this.$t('newRegister.pleaseAgreeNotice'))
      } else {
        let registryType = ''
        if (this.registryType.indexOf(8) > -1) {
          registryType = 12
        } else if (this.registryType.indexOf(3) > -1) {
          registryType = 4
          if (this.registryType.indexOf(2) > -1 && this.registryType.indexOf(5) > -1) {
            registryType = 9
          }
        } else if (this.registryType.indexOf(5) > -1) {
          registryType = 6
        } else if (this.registryType.indexOf(6) > -1) {
          registryType = 7
        } else if (this.registryType.indexOf(7) > -1) {
          registryType = 8
        } else if (this.registryType.indexOf(1) > -1) {
          registryType = 3
          if (this.registryType.indexOf(2) > -1) {
            registryType = 1
          } else {
            registryType = 3
          }
        } else if (this.registryType.indexOf(2) > -1) {
          registryType = 2
        } else if (this.registryType.indexOf(4) > -1) {
          registryType = 5
        }
        let isInCommunity = (this.registryType.indexOf(2) > -1 || this.registryType.indexOf(4) > -1) ? '1' : '0'
        if(this.$isTenant == 1 || this.title == '租客登记') {
          Vue.prototype.$isZuke = true
        }else {
          Vue.prototype.$isZuke = false
        }
        console.log(registryType)
        Vue.prototype.$userType = (this.registryType.indexOf(5) > -1 || this.registryType.indexOf(6) > -1 || this.registryType.indexOf(8) > -1) ? '2' : '1'
        this.$router.push({
          path: '/newRegister-form',
          query: {
            registryType,
            isInCommunity,
            title: this.title,
            houseId: this.$route.query.houseId,
            subarea: this.$route.query.subarea,
            houseName: this.$route.query.houseName,
            myHouse: this.$route.query.myHouse,
            isList: this.$route.query.isList
          }})
      }
    }
  }
}
</script>

<style scoped>
.top {
  padding: 24px 30px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top1 {
  width: 262px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-image: url("~@/assets/img/progress-active.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 26px;
  color: #4581F8;
}
.top2 {
  background-image: url("~@/assets/img/progress.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #999;
}
.select-community {
  margin-top: 24px;
  padding: 24px 30px;
  background: #fff;
}
.select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 26px;
  color: #666;
}
.community {
  line-height: 44px;
  font-size: 30px;
  color: #333;
  margin-top: 12px;
  font-weight: 600;
}
.select-registryType {
  margin-top: 16px;
  background: #fff;
}
.title {
  line-height: 96px;
  color: #333;
  padding: 0 30px;
  font-size: 32px;
  font-weight: 600;
}
.img-icon {
  width: 44px;
  height: 44px;
}
.van-cell {
  padding: 24px 30px;
}
.van-cell__title {
  line-height: 48px;
  color: #333;
  font-size: 34px;
  font-weight: 600;
}
::v-deep .van-checkbox__icon {
  height: auto;
}
.van-cell::after {
  right: 0;
  left: 0;
  border-color: #eee;
}
.btn {
  position: fixed;
  bottom: 40px;
  width: 690px;
  left: 30px;
  line-height: 88px;
  text-align: center;
  color: #fff;
  background: #4581F8;
  border-radius: 8px;
  font-size: 32px;
}
.title-sub {
  color: #999; font-weight: normal;
}
.bottom-bar {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  background: #fff;
  padding: 24px 30px;
  border-top: 1px solid #eee;
  z-index: 40;
}
.agree-row {
  display: flex; align-items: center; gap: 6px;
  margin-bottom: 40px;
}
.agree-check {
  font-size: 30px; color: #666;
}
.terms-link {
  color: #f88554; font-size: 30px; text-decoration: underline;
}
.countdown-text {
  font-size: 22px; color: #999;
  margin: 0 0 12px 30px;
}
.next-btn {
  width: 100%; padding: 24px 0; border: none; border-radius: 12px;
  font-size: 32px; font-weight: 600; color: #fff; background: #4080ff;
}
.terms-popup {
  border-radius: 24px 24px 0 0;
}
.terms-hd {
  padding: 28px 30px 18px; border-bottom: 1px solid #eee; text-align: center;
  h2 { font-size: 32px; font-weight: 600; color: #222; margin: 0; }
}
.terms-bd {
  max-height: 50vh; overflow-y: auto; padding: 24px 30px;
  font-size: 26px; color: #666; line-height: 1.8;
}
.terms-sec {
  margin-bottom: 24px;
  h4 { font-size: 28px; font-weight: 600; color: #333; margin: 0 0 10px; }
  h5 { font-size: 26px; font-weight: 600; color: #555; margin: 0 0 8px; }
  p { margin: 0 0 6px; }
  strong { color: #4080ff; }
  .terms-tip { color: #999; font-style: italic; margin-top: 8px; }
}
.terms-ft {
  padding: 24px 30px; border-top: 1px solid #eee; background: #fff;
}
.terms-btn {
  width: 100%; padding: 20px 0; border: none; border-radius: 12px;
  font-size: 30px; font-weight: 600; color: #fff; background: #4080ff;
  &:disabled { background: #ccc; cursor: not-allowed; }
}
</style>
